<template>
    <v-card flat
        :class="[row ? '_card-row' : '_card-column', { '_card-large': large }, { '_card-small': small }, { '_card-reverse': reverse }, 'blog-card']">
        <v-layout>
            <v-flex class="_flex-header">
                <div class="_card-header pa-0">
                    <v-btn v-if="!hideActions" @click="favourites" class="_card-btn-action" :ripple="false" icon>
                        <span :class="`icon-NG_FAVOURITES${item.is_favorite ? '_FILL' : ''}`"></span>
                    </v-btn>
                    <div @click="openArticleInNewTab(slug)">
                        <v-img                            
                            :src="getImageUrl(item)"
                            :lazy-src="getImageUrl(item)"
                            :alt="item.name || 'Article image'">
                            <v-layout v-if="item.image && item.image.path" slot="placeholder" fill-height align-center
                                justify-center ma-0>
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            </v-layout>
                        </v-img>

                    </div>
                </div>
            </v-flex>
            <div @click="openArticleInNewTab(slug)">
                <v-flex class="_card-body">
                    <!-- <router-link :to="`/blog/article/${item.id}`" tag="div">
                        <h3 v-line-clamp:20="2" class="_card-body--title">{{item.name}}</h3>
                    </router-link> -->
                    <div v-if="getCategoryName() !== 'Nanny'" v-line-clamp:20="3" class="_card-body--description font--medium">{{ getTitle() }}</div>
                    <div v-line-clamp:20="3" class="_card-body--title font--light"> {{ getText()
                    }} </div>
                    <v-btn :to="`/blog/category/${getCategoryName()}`" round outline color="primary" class="mx-0">#{{ getCategoryName() }}</v-btn>
                </v-flex>
            </div>

        </v-layout>
    </v-card>
</template>

<script>
import Article from '@/models/ArticleClass'
import slugify from 'slugify'

export default {
    name: 'app-card-article2',

    props: {
        row: Boolean,
        reverse: Boolean,
        large: Boolean,
        small: Boolean,
        hideActions: Boolean,
        item: Article
    },

    computed: {
        slug() {
            return slugify(this.item.metaslug || '', { lower: true, strict: true })
        }
    },

    mounted() {
        // console.log('category item:', this.item);
        this.injectSchemaScript()
    },

    methods: {
        getTitle() {
            return this.item.getTitle()
        },
        getText() {
            return this.item.getText()
        },
        getCategoryName() {
            return this.item.getCategoryName()
        },
        favourites() {
            if (this.$auth.check()) {
                let _action = !this.item.is_favorite ? 'ADD' : 'DELETE'
                this.item.is_favorite = !this.item.is_favorite
                this.$store.dispatch(`favourites/FAVOURITES_${_action}`, {
                    type: 'ARTICLE',
                    id: this.item.id
                }).then(data => {
                    if (this.item.is_favorite) {
                        this.$store.commit(`favourites/articles/FAVOURITES_PUSH_ITEM`, new Article(data.object))
                    } else {
                        this.$store.commit(`favourites/articles/FAVOURITES_DELETE`, this.item.id)
                    }
                }).catch(() => (this.item.is_favorite = !this.item.is_favorite))
            } else {
                this.$router.push('signup')
            }
        },

        injectSchemaScript() {
            if (this.item && this.item.schema_script) {
                const wrapper = document.createElement('div')
                wrapper.innerHTML = this.item.schema_script

                const scripts = wrapper.querySelectorAll('script')
                scripts.forEach((script) => {
                    const newScript = document.createElement('script')
                    newScript.type = 'application/ld+json'
                    if (script.src) {
                        newScript.src = script.src
                    } else {
                        newScript.textContent = script.textContent
                    }
                    document.body.appendChild(newScript)
                })
            }
        },
        getImageUrl(item) {
            if (!item || !item.image) {
                return 'https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/chatroom/789/Gxtdo7R4vmdoUEk80gLXLNTcFOq1qzBHXCkkmQgA.png';
            }

            // If image is an object with path
            if (typeof item.image === "object" && item.image.path) {
                return item.image.path;
            }

            // If image is already a string (URL)
            if (typeof item.image === "string") {
                return item.image;
            }

            return 'https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/chatroom/789/Gxtdo7R4vmdoUEk80gLXLNTcFOq1qzBHXCkkmQgA.png';
        },

        openArticleInNewTab(slug) {
            // 1. Resolve the Vue Router link into a full, valid URL string
            const routeData = this.$router.resolve({ 
                path: `/blog/${slug}` 
            });

            // 2. Use window.open() with the generated URL
            // Include security best practices rel attributes in the new window reference
            window.open(routeData.href, '_blank', 'noopener noreferrer');
        }
    }
}


</script>


<style lang="stylus" scoped>
    .v-card
        background-color transparent !important
        max-width 324px
        border 1.16px solid #B7B7FF !important
        border-radius 9px
        padding 12px
        margin auto

        &._card-row
            > .layout
                flex-direction column

            &._card-reverse
                > .layout
                    @media (min-width 768px)
                        flex-direction row-reverse

        &._card-column
            > .layout
                flex-direction column

            ._flex-header
                padding-bottom 0 !important
            ._card-header
                background-color transparent
                overflow: hidden;

        ._card-header
            background-color transparent
            cursor pointer
            text-align right
            padding 10px
            position relative
            ._card-btn-action
                position absolute
                background #fff
                color var(--blue)
                width 30px
                height 30px
                line-height 0
                font-size 14px
                text-align center
                top 12px
                right 12px
                z-index 5

                &:hover
                    &:before
                        background-color transparent

        ._card-header
            transition .3s
            &:hover
                opacity .9

        ._card-body
            &--title
                margin-top 30px
                cursor pointer
                word-break normal !important
                height 48px
                line-height 24px
                overflow hidden
                display -webkit-box
                -webkit-line-clamp 2
                -webkit-box-orient vertical
                &:hover
                    opacity .9
                    text-decoration underline

            &--description
                height 72px
                line-height 24px
                overflow hidden
                display -webkit-box
                -webkit-line-clamp 3
                -webkit-box-orient vertical
                margin-top 16px
                margin-bottom 6px
                word-break normal !important
            .v-btn
                font-size 16px
                height 28px
                &:before
                    opacity 0
                &:hover:before
                    opacity 1

    @media (min-width: 768px)
        .v-card
            max-width 360px

            &._card-row
                max-width 100%

                > .layout
                    flex-direction row

                ._card-body
                    &--title
                        margin-top 0

            &._card-small
                ._card-header
                    min-width 324px
                    height 223px

                ._card-body
                    padding 16px 60px

            &._card-large
                > .layout
                    align-items center
                ._card-header
                    min-width 400px
                    height 318px

                ._card-body
                    padding 16px 60px

            ._card-header
                min-width 100%

            ._card-body
                &--description
                    margin-top 24px
                    margin-bottom 24px
                .v-btn
                    height 32px
                    &:hover {
                      border-color white
                    }
            &._card-large
                ._card-header
                    height 318px
    @media (min-width: 1264px)
        .v-card
            &._card-large
                ._card-header
                    min-width 460px
                    height 318px
</style>



// WEBPACK FOOTER //
// src/components/app-card/app-card-article2.vue